function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.633,
  y1: 0.045,
  x2: 0.735,
  y2: 0.975,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#8cff90"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#3093f9"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "landing-bcg",
  d: "M268.442,143.7c278.565-148.328,482.17,68.317,352.3,270.112S322.95,524.373,331.267,768.608,76.507,1162.374-122.888,1038.726-436.63,1168.491-593.4,999-657.17-77.5-391.5-187.638-10.123,292.03,268.442,143.7Z",
  transform: "translate(669.768 201.439)",
  fill: "url(#linear-gradient)"
});

var SvgLandingBcg = function SvgLandingBcg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1330.609 1284.479",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLandingBcg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/landing-bcg.231bd309.svg";
export { ForwardRef as ReactComponent };